export const Data = {
  sidebar: [
  ],
  top: {
    title: 'Xin chào 👋',
    content: 'Mình là <a href=\'https://fb.com/quylua98\'>Quý</a>, cảm ơn bạn đã ghé thăm xD',
  },
};